import {useState, useContext, useEffect, useRef, useMemo} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { H2, Panel, Flex, FlexItem, Button, Text, Box, Table, Form, FormGroup, Input, Select, ProgressCircle, Fieldset ,Textarea, Datepicker, Timepicker } from '@bigcommerce/big-design';
import { ArrowBackIcon, FileDownloadIcon, VisibilityIcon, DeleteIcon } from '@bigcommerce/big-design-icons';
import Container from '../../ui/Container';
import AppContext from '../../AppContext';
import { toEventData, toProductData } from '../../../utils/format-event';
import Attendee from './Attendee';
import Papa from 'papaparse';

export default function EventAttendees({ }) {
    const { user_token, store_hash } = useContext(AppContext);

    const [attendees, setAttendees] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [name, setName] = useState('');


    let params = useParams();
    const navigate = useNavigate();
    const handleBack = () => {
        navigate('/events');
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('name')) {
            setName(urlParams.get('name'));
        }
        else {
            setName(`Event ${params.id} Attendees`);
        }
        getAttendees();
    }, []);

    const getAttendees = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}/events/getEventAttendees?signed_payload=${user_token}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    eventId: params.id
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log("data", data);
                const attendees = data.map(a => {
                    const formValues = JSON.parse(a.value);
                    return {
                        orderId: a.key.split('_')[0],
                        id: a.key,
                        name: formValues.find(f => f.label === 'Name')?.value || '',
                        email: formValues.find(f => f.label === 'Email')?.value || '',
                        formValues: formValues
                    }
                });
                setAttendees(attendees);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const handleView = (id) => {
        console.log("view", id);
        setIsOpen(id);
    };

    const handleExport = () => {
        const headers = attendees.reduce((acc, a) => {
            a.formValues.forEach(f => {
                if (!acc.includes(f.label)) {
                    acc.push(f.label);
                }
            });
            return acc;
        }, []);


        const csv = Papa.unparse(attendees.map(a => {
            const row = {};
            a.formValues.forEach(f => {
                row[f.label] = f.value;
            });
            return row;
        }),
        {
            header: true,
            columns: headers
        });
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `${name}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    console.log("attendees", attendees);

    return (
        <Container className="checkout">
            <Box>
                <Flex justifyContent="space-between">
                    <FlexItem>
                        <H2>Attendees</H2>
                    </FlexItem>
                    <FlexItem>
                        <Button onClick={handleExport} iconLeft={<FileDownloadIcon />}>
                            Export Report
                        </Button>
                        <Button onClick={handleBack} variant='secondary' iconLeft={<ArrowBackIcon />}>
                            Back
                        </Button>
                    </FlexItem>
                </Flex>
                <Panel marginTop={'large'}>
                    {!isLoading ? 
                    <Table
                        columns={[
                            { header: 'Name', hash: 'name', render: ({ name }) => name },
                            { header: 'Email', hash: 'email', render: ({ email }) => email },
                            { header: 'Order', hash: 'order', render: ({ orderId }) => orderId },
                            { header: 'View Submission', hash: 'actions', align: 'right', render: ({ id }) => {
                                return (
                                    <Button onClick={() => handleView(id)} variant='subtle' iconOnly={<VisibilityIcon title="view" />}></Button>
                                )} },
                        ]}
                        items={attendees}
                        key={`table`}
                    />  : 
                    <div className={"loading-circle"}>
                        <ProgressCircle size="large" />
                    </div>}
                </Panel>
                {isOpen !== false && <Attendee isOpen={isOpen === false ? false : true} setIsOpen={setIsOpen} attendee={attendees.find(a => a.id === isOpen)} />}
            </Box>
        </Container>
    );
}
